import axios, { AxiosPromise } from "axios";
import _get from "lodash/get";

import constants from "./index";

import { setApiAuthenticationHeader } from "utils/setApiAuthenticationHeader";
import store from "store";
import authTypes from "store/auth/types";

const { PORTAL_MANAGER_API_SERVER } = constants;

// Configure axios instances
axios.defaults.baseURL = PORTAL_MANAGER_API_SERVER;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const axiosErrorHandler = (error: any) => {
  if (
    (error.config && error.response && error.response.status === 401) ||
    error.response.status === 403
  ) {
    if (window.location.pathname !== "/login") {
      // TODO: fix redux store types
      // localStorage.clear();
      sessionStorage.clear(); // TODO: switch with localStorage
      setApiAuthenticationHeader();

      store.dispatch({
        type: authTypes.LOGOUT_SUCCESS,
        payload: {
          msg: "Logout success!",
        },
      });

      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
};

//====================================================================================
// Create Portal Manager Axios instance
const pmConfig = {
  baseURL: PORTAL_MANAGER_API_SERVER,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json, text/plain, */*",
  },
};
const pmAxios = axios.create(pmConfig);

pmAxios.interceptors.response.use((response) => response, axiosErrorHandler);

//====================================================================================

// Axios wrapper to handle error
const axiosWrapper = (apiCall: AxiosPromise) =>
  apiCall.then((res) => res.data).catch((err) => Promise.reject(err));

// Define API calls
let portalManagerApi = {
  helpCenter: {
    getHelpCenterLinks: (page: string, type: string) =>
      axiosWrapper(
        pmAxios.get(`CDB/GetHelpCenterLinks?page=${page}&type=${type}`)
      ),
  },
  public: {
    getCompanies: () => {
      return axiosWrapper(pmAxios.get("Company/GetCompanies"));
    },
  },
};

export { portalManagerApi, pmAxios };

export default portalManagerApi;
